import { combineReducers } from "@reduxjs/toolkit"

// reducers
import authSlice from "./slices/authSlice"
import configSlice from "./slices/configSlice"
import signupSlice from "./slices/signupSlice"

const reducers = combineReducers({
  auth: authSlice,
  config: configSlice,
  signup: signupSlice,
});

export default reducers;
